<script>
import Spinner from "../../components/Spinner"
import Ajouter from "../../components/PageForm"
import Section from "../../components/PageSection"
import FactureItem from "../../components/projets/Factures/factureItem"
import LigneAFacturer from "../../components/projets/Factures/ligneFormulaire"
import LigneAvancement from "../../components/projets/Factures/ligneAvancement"

import {updateMontant} from '../../mixins/updateMontant.js';

export default {
  name: 'Factures',
  components: {
    Spinner,
    Ajouter,
    Section,
    FactureItem,
    LigneAFacturer,
    LigneAvancement,
  },
  data(){
    return{
      factures: [],
      phases: [],
      fullyLoaded: false,
      dateNouvelleFacture: (new Date).toISOString().slice(0,10),
      montantsLignes: [],
      totalht: 0,
      totalttc: 0,
    }
  },
  computed:{
    facturationTotale(){
      let accumulateurHonos = 0
      for (let item of this.phases){
        accumulateurHonos += item.honos
      }

      let accumulateurFactured = 0
      for (let item of this.phases){
        accumulateurFactured += item.factured
      }

      return {pourcentage: Math.round(accumulateurFactured / accumulateurHonos * 1000)/10, resteAfact: accumulateurHonos - accumulateurFactured}
    },
    totalTVA(){
      return Math.round((this.totalttc - this.totalht)*100)/100
    }
  },
  mixins:[
    updateMontant,
  ],
  async mounted(){
    //Chargement des phases du projet 
    const promisePhases = this.$axios.get('phases/getByProjet/withEuros/' + this.$route.params._id + '/' + this.$store.state.auth.currentAgence._id)
    .then(response => {
      this.phases = response.data;
    })
    .catch(err => console.log (err.message))

    //Chargement des factures existantes pour ce projet
    const promiseFactures = this.$axios.get('factures/getByProjet/' + this.$route.params._id + '/' + this.$store.state.auth.currentAgence._id)
    .then(response => {
      this.factures = response.data.sort((a, b) => {
        if (a.date < b.date){return  1}
        if (a.date > b.date){return -1}
      });
    })
    .catch(err => console.log (err.message))

    await Promise.all([promisePhases, promiseFactures,])

    this.fullyLoaded = true;
  },
  methods:{
    //Ajouter une phase dans la nouvelle facture
    toFact(phaseId){
      
      //Si la phase est déjà affichée dans le formulaire, on la masque et supprime ses valeurs du tableau de lignes
      if (this.phases.find(e => e._id == phaseId).visible) {
        this.phases.find(e => e._id == phaseId).visible = false;
        this.updateFormFooter({phaseId: phaseId, ht: 0, ttc: 0})

      //Sinon on l'y affiche et on ajoute ses valeurs dans la tableau de lignes
      } else {
        //Utilisation de Set pour que cela soit reactive
        this.$set(this.phases.find(e => e._id == phaseId), 'visible', true)
      }      
    },

    //Ajouter une nouvelle facture
    async ajouter(payload){
      let newFact = {}
      let newLine = {}
      let newLines = []

      //Initialisation de la nouvelle facture
      newFact = {
        agenceId  : this.$store.state.auth.currentAgence._id,
        projetId  : this.$route.params._id,
        date      : new Date(payload[0]),
        numero    : payload[1],
      }

      //Envoi de la facture au serveur
      await this.$axios.post('factures/register', newFact)
      .then(response => {
        //Ajout de l'id de l'objet nouvellement créé par le serveur pour pouvoir manipuler l'objet depuis le client
        newFact._id = response.data.factureId
        newFact.date = response.data.date
      })
      .catch(err => console.log(err.message))

      //Trier payload pour ne conserver que les valeurs des lignes
      payload.splice(0, 2); //J'enlève les deux premiers éléments (date & numero de facture)
      payload.pop();        //J'enlève le dernier élément (le submit)

      // Envoyer toutes les lignes à la fois
      let allLines = [] //Un tableau pour stocker toutes les promesses
      let allGood  = true

      for (let i = 0; i< payload.length; i += 4){ //i += 4 car j'ai 4 élément par ligne, compris l'input masqué de l'Id
        //Initialisation d'une nouvelle ligne
        newLine = {
          agenceId    : this.$store.state.auth.currentAgence._id,
          factureId   : newFact._id,
          phaseId     : payload[i+0],
          pourcentage : parseFloat(payload[i+1]),
          montant     : parseFloat(payload[i+2]),
          tva         : parseFloat(payload[i+3]),
        }

        //Envoi de la ligne au serveur
        window['promise'+ i] = this.$axios.post('factureLines/register/' + this.$store.state.auth.currentAgence._id, newLine)
        .then(res => {
          newLines.push(res.data.lineFromServer)
        })
        .catch(err => {
          console.log(err.message)
          allGood = false
        })

        //Stockage de la promesse
        allLines.push(window['promise'+i])
      }

      // Attendre qu'elles soient toutes terminées. Avec un promise.all, à la moindre erreur je lancerai la suite sans attendre le succès des autres. Donc au moment de les supprimer (puisqu'il y a eu une erreur quelque part, je vais tout supprimer), elles ne serait peut-être pas encore enregistrées.
      await Promise.allSettled(allLines)
      // Finalement il semble que si, que promise.all attende tout... bizarre... Je le laisse au cas où...

      if (allGood){
        console.log('succès')
        //Je masque toutes les phases du formulaire (reset)
        for (let i = 0; i < this.phases.length; i++) {
          this.$set(this.phases[i], 'visible', false)
        }

        //Et je reset le formFooter
        this.montantsLignes = []
        this.totalht = 0
        this.totalttc = 0

        //Ajout des lignes à la facture (pour envoi au client)
        newFact.lines = newLines.sort ((a, b) => {
          if (a.rank < b.rank){return -1;}
          if (a.rank > b.rank){return  1;}
        })


        //Envoie de la facture au client
        this.factures.push(newFact)
        this.factures.sort((a, b) => {
          if (a.date < b.date){return  1}
          if (a.date > b.date){return -1}
        });

        //Mise à jour de l'avancement
        for (let line of newLines){
          this.phases.find(e => e._id == line.phaseId).factured += line.montant
        }

      } else {
        console.log('echec')
        //Suppression des lignes écrites sur le serveur
        for (let item of newLines){
          this.$axios.delete('factureLines/' + item._id)
        }

        //Suppression de la facture sur le serveur
        this.$axios.delete('factures/' + newFact._id)
      }
    },

    //Supprimer une facture
    deleteFacture(evt){
      //Suppression des lignes
      this.$axios.delete('factureLines/byFacture/' + evt)
      .then(response => {
        console.log(response.data.message)
      })
      .catch(err => console.log(err))


      //Supression de la facture
      this.$axios.delete('factures/' + evt)
        .then(response => {
            console.log(response.data.message);
            
            //Si suppression ok sur le server, suppression sur le client.
            const index = this.factures.findIndex(e => e._id === evt);
            if( index >= 0 ){
                for (let line of this.factures[index].lines){
                  this.phases.find(e => e._id == line.phaseId).factured -= line.montant
                }
                this.factures.splice(index, 1);
            } else {
                console.log("_id non reconnue sur le client, mais suppression effective sur le server.");
            }
        })
        .catch(err => {
            console.log(err)
        });
    },

    //Réception des infos des enfants pour mettre à jour les totaux du formulaire
    updateFormFooter(evt){
      //Supprimer l'ancienne valeur si elle existe
      let indexElmt = this.montantsLignes.findIndex(e => e.phaseId == evt.phaseId)
      if (indexElmt >= 0){
        this.montantsLignes.splice(indexElmt,1)
      }

      //Ajouter la nouvelle valeur
      this.montantsLignes.push(evt)

      //Mettre à jour les totaux
      this.totalht = this.montantsLignes.reduce((a, b) => a + (parseFloat(b['ht']  || 0)), 0);
      this.totalttc= this.montantsLignes.reduce((a, b) => a + (parseFloat(b['ttc'] || 0)), 0);
      
    },
  }
}
</script>


<template>
      <!-------------->
      <!--    ID    -->
      <!-------------->

      <!-- dans PageProjet.vue -->
    <Spinner v-if="!fullyLoaded"/>
    <div v-else class="FacturesMain">

      <!---------------->
      <!--   Helper   -->
      <!---------------->
      <div class="introHelper">
        Voici l'état actuel de la facturation pour ce projet. Cliquez sur l'icône <span class="material-icons introHelper__icon">arrow_right</span> pour facturer tout ou partie de la phase sélectionnée.
      </div>

      <!---------------->
      <!-- Avancement -->
      <!---------------->
      <div class="avancement">
        <Section text="Avancement" underlined="true" class="sectionInfos">
          <template v-slot:body>
            <div class="sectionInfos__alignFirst"></div>
            <LigneAvancement v-for="phase in phases" :key="phase._id" class="ajouter__container__line" :phaseId="phase._id" :phaseName="phase.name" :visible="phase.visible" :avancement="Math.round(phase.factured / phase.honos * 1000)/10" @toFact="toFact($event)" />


            <div class="sectionInfos__blank"></div>

            <div class="sectionInfos__line">
              <div>Projet facturé à :</div><div> {{facturationTotale.pourcentage.toFixed(2)}}  %</div>
            </div>
            <div class="sectionInfos__line">
              <div>Reste à facturer :</div><div> {{updateMontant(facturationTotale.resteAfact, 2).str}}  €</div>
            </div>
            
          </template>
        </Section>
      </div>

      <!-------------------->
      <!--   Formulaire   -->
      <!-------------------->
      <Ajouter class="ajouter" label="Ajouter une facture" @submit="ajouter($event)">
        <template v-slot:body>
          <div class="ajouter__container">
            <div class="ajouter__container__header">
              <input type="date" required class="ajouter__input" v-model="dateNouvelleFacture"/>
              <input type="text" required class="ajouter__input" placeholder="N° de facture"/>
            </div>
            <LigneAFacturer v-for="phase in phases" :key="phase._id" class="ajouter__container__line" :phaseId="phase._id" :phaseName="phase.name" :visible="phase.visible" :honos="phase.honos" :factured="phase.factured" @update="updateFormFooter($event)"/>
            <div class="ajouter__container__footer">
              <div class="ajouter__container__footer__horLine"></div>
                <!-- 2 empty div pour gérer la grid sans css -->
                <div></div>
                <div class="ajouter__container__footer__totaux">Total : </div>
                <div class="ajouter__container__footer__totaux"> {{totalht.toFixed(2)}} <span class="ajouter__container__footer__totaux__unit">€<sup>ht</sup></span></div>
                <div class="ajouter__container__footer__totaux"> {{totalTVA.toFixed(2)}} <span class="ajouter__container__footer__totaux__unit">€</span></div>
                <div class="ajouter__container__footer__totaux"> {{totalttc.toFixed(2)}} <span class="ajouter__container__footer__totaux__unit">€<sup>ttc</sup></span></div>
              <input type="submit" class="ajouter__container__footer__submit" value="Facturer">
            </div>
          </div>
        </template>
      </Ajouter>

      <!-------------------->
      <!--    Factures    -->
      <!-------------------->
      <Section text="" class="sectionFactures">
        <template v-slot:body>
          <div v-if="factures.length == 0" class="sectionFactures__empty">Il n'y a encore aucune facture pour ce projet.</div>
          <FactureItem v-for="facture in factures" :key="facture._id" :factureId="facture._id" :date="facture.date" :numero="facture.numero" :lines="facture.lines" @suppr="deleteFacture($event)"/>
        </template>
      </Section> 

    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.FacturesMain{
  @include grid-alpha-noFirst;
}

.introHelper{
  grid-column: 1 / span 2;
  @include myFont;
  color: $black-bolder;
  font-size: 13px;

  &__icon{
    vertical-align: middle;
    margin: -1px -3px 1px -3px;
  }
}

.avancement{
  grid-column-start: 1;
}

.sectionInfos{
  margin: 22px 0 0 0; //Pour aligner le trait de la section avec celui des champs du formulaire

  &__alignFirst{
    margin: 20px 0 0 0;
  }

  &__line{
    height: 20px; //Idem lignes ajouter
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include myFont;
    font-size: 13px;
    margin: 5px 0 0 0;
    color: $black-bolder;

    &__block{
      display: flex;
      align-items: center;
    }
  }

  &__blank{
    margin: 25px 0 0 0;
  }

}

.ajouter{
  grid-column : 2 / span 2;
  grid-row    : 2;
  // min-width: 600px;


  &__container{
    display: flex;
    flex-direction: column;
    width: 100%;

    &__header{
      display: flex;
      align-items: bottom;
      margin: 0 0 20px 0;

      & input{
        margin: 0 20px 0 0;
      }
    }

    &__line{
      margin: 0 0 5px 0;
      height: 20px; //Idem lignes avancement
    }

    &__footer{
      margin: 10px 0 0 0;
      display: grid;
      grid-template-columns: 3fr 1fr 2fr 2fr 2fr;

      &__horLine{
        grid-column: 2 / span 4;
        border-top: $black solid 1px;
        margin: 3px 0 0 0;
      }

      &__totaux{
        justify-self: right;
        @include myFont;
        color: $black-bold;
        font-size: 13px;

        &__unit{
          margin: 0 0 0 3px;
        }
      }

      &__submit{
        grid-column: 5;
        margin: 25px 0 0 0;
        @include myButton;
      }
    }
  }
}

.sectionFactures{
  grid-column : 2 / span 2;
  grid-row    : 3;

  &__empty{
    @include myFont;
    font-size: 12px;
    color: $black;
  }
}


</style>